import { render, staticRenderFns } from "./footerBlock.vue?vue&type=template&id=938b9524&scoped=true&"
import script from "./footerBlock.vue?vue&type=script&lang=js&"
export * from "./footerBlock.vue?vue&type=script&lang=js&"
import style0 from "./footerBlock.vue?vue&type=style&index=0&id=938b9524&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938b9524",
  null
  
)

export default component.exports